
import {  Link } from "react-router-dom"
import { reduxForm , handleSubmit, FieldArray,Field, startSubmit, formValueSelector} from 'redux-form'
import { loadAdAction,addReguserNow} from '../../../actions'
import {SVADFORM,SV_SERVICES, SV_SERVER_ADDRESS, SV_URL} from '../../../constants'
import { Icon } from 'antd'

import CreateAddressFormBusCom from './CreateReguserFormBusCom'
import '../../../css/svformwerror.css'
const _ = require('lodash')
const React = require('react')
//import { loadAdAction} from '../../actions'

const HeartSvg = () => (
    <svg width="1em" height="1em" fill="currentColor" viewBox="0 0 1024 1024">
      <path d="M923 283.6c-13.4-31.1-32.6-58.9-56.9-82.8-24.3-23.8-52.5-42.4-84-55.5-32.5-13.5-66.9-20.3-102.4-20.3-49.3 0-97.4 13.5-139.2 39-10 6.1-19.5 12.8-28.5 20.1-9-7.3-18.5-14-28.5-20.1-41.8-25.5-89.9-39-139.2-39-35.5 0-69.9 6.8-102.4 20.3-31.4 13-59.7 31.7-84 55.5-24.4 23.9-43.5 51.7-56.9 82.8-13.9 32.3-21 66.6-21 101.9 0 33.3 6.8 68 20.3 103.3 11.3 29.5 27.5 60.1 48.2 91 32.8 48.9 77.9 99.9 133.9 151.6 92.8 85.7 184.7 144.9 188.6 147.3l23.7 15.2c10.5 6.7 24 6.7 34.5 0l23.7-15.2c3.9-2.5 95.7-61.6 188.6-147.3 56-51.7 101.1-102.7 133.9-151.6 20.7-30.9 37-61.5 48.2-91 13.5-35.3 20.3-70 20.3-103.3 0.1-35.3-7-69.6-20.9-101.9z" />
    </svg>
  );


const HeartIcon = props => <Icon component={HeartSvg} {...props} />;

class SVReguserContainer extends React.Component {

    constructor(props) {
        super(props)
        let me = this
        this.getAppDetails = this.getAppDetails.bind(this) 
        this.title = 'AddressContainer'
        this.svsubmitparent = this.svsubmitparent.bind(this)
        
      
    }

    componentWillMount()	{
        console.log('sv--task=--- link sends us svparams good')
        console.log(this.props.svparams)
         //console.log(this.props.svparams.id)
         let id;
         if(this.props.svparams){
            id = this.props.svparams.id
         
         }else{
          console.log('svparams not called by router we might be creat')
          id = -11;
         }
        
    console.log('sbv--sjourn id ****+++++++++++++++++++++++++++ we will use _doc as the space has details of sohourn as single flat indxex:'+ id)
    
    
       this.getAppDetails(id)
       // this.props.priceAndTexNow(id);
   

	}
    getAppDetails(paramQSpaceId){
        //loadReguserDet(id)
        let id = -1
        if(paramQSpaceId ){
            id  = parseInt(paramQSpaceId)
        }
        if(id < 0){
            console.log("id*  cerate ******", id)
            return
        }
        console.log("id* addressr det or edit******", id)
        this.props.loadReguserDet(id)
        //this.props.sojDetailsAndImagesSV("mancreek") 
        /*this.props.getSojournDetails("mancreek") */
       
    }
    svsubmitparent(values){
        let me = this
      console.log('^^^^^^^^^^^^^^^^^^^^^^^^^^^^^sv submit callback**********parent')
      console.log(values)
     
     
      let comCardAndTraveller = {
        addressNew : values
       
      }  
      
     return this.props.addReguserNow(comCardAndTraveller)
  
    }

    render() {
        const lastestUpdateDate = 'Data Refresh Daily'
        const { title, svsubmitparent} = this
        let det = {
            "id": 1,
            "fname": "John",
            "lname": "Glen",
            "email": "john123@yahoo.com",
            "username": "pet123@yahoo.com",
            "password": "pet123",
            "encpassword": "pet123@yahoo.com",
            "phone": "5121234356"
        }
        if (this.props.my_data_reguserdet ) {
            det = this.props.my_data_reguserdet
            
          
        }
       /*to do we donot neeed care - terrain is card . just planin textstyel images page to hsow terrrain  */
    

       return (
           
        <div>
            <CreateAddressFormBusCom det={det}  svsubmitparent={svsubmitparent} onSubmit={svsubmitparent}></CreateAddressFormBusCom>
            {/* 
            <PaymentCardFormBusCom  onSubmit={svsubmitparent}   ></PaymentCardFormBusCom>
                 */}
            </div>   
            )
        
    }

}

export default SVReguserContainer